<template>
  <div>

    <!----- features ----->
    <div class="form-group row"
         v-if="('features' in protocol.dataFields)">
      <div class="col-md-12">
        <mdc-textfield id="features"
                       :label="'protocol.features' | trans"
                       type="text"
                       multiline
                       rows="2"
                       name="features"
                       ref="features"
                       :class="{'is-invalid': errors.has('features')}"
                       v-validate="'max:2500'"
                       v-model="protocol.dataFields.features"
                       data-vv-validate-on="none"
                       :data-vv-as="'validation.attributes.protocol.features' | trans"/>
        <span class="invalid-feedback" v-if="errors.has('features')">
                                    <strong>{{ errors.first('features') }}</strong>
                                </span>
      </div>
    </div>
    <!----- features ----->

    <!----- errorCorrection ----->
    <div class="form-group row"
         v-if="('errorCorrection' in protocol.dataFields)">
      <div class="col-md-12">
        <mdc-textfield id="errorCorrection"
                       :label="'protocol.errorCorrection' | trans"
                       type="text"
                       ref="errorCorrection"
                       multiline
                       rows="2"
                       name="errorCorrection"
                       :class="{'is-invalid': errors.has('errorCorrection')}"
                       v-validate="'max:2500'"
                       v-model="protocol.dataFields.errorCorrection"
                       v-on:input="setIsChanged(true)"
                       data-vv-validate-on="none"
                       :data-vv-as="'validation.attributes.protocol.errorCorrection' | trans"/>
        <span class="invalid-feedback"
              v-if="errors.has('errorCorrection')">
                                    <strong>{{ errors.first('errorCorrection') }}</strong>
                                </span>
      </div>
    </div>
    <!----- errorCorrection ----->

    <!----- criteriaEndSession ----->
    <div class="form-group row"
         v-if="('criteriaEndSession' in protocol) && selectedTeachingMethodID !== 7">
      <div class="col-md-12">
        <mdc-textfield type="text"
                       ref="searchCriteriaEndSession"
                       name="criteriaEndSession"
                       :visible="visible"
                       v-model="protocol.criteriaEndSession"
                       data-vv-validate-on="none"
                       :class="{'is-invalid': errors.has('criteriaEndSession')}"
                       v-validate="'max:1000'"
                       :label="'protocol.criteria_end_session' | trans"
                       :data-vv-as="'protocol.criteria_end_session' | trans"/>

        <span class="invalid-feedback"
              v-if="errors.has('criteriaEndSession')">
                  <strong>{{ errors.first('criteriaEndSession') }}</strong>
                </span>
      </div>
    </div>
    <!----- criteriaEndSession ----->

    <!----- criteriaEndTeaching ----->
    <div class="form-group row"
         v-if="('criteriaEndTeaching' in protocol) && selectedTeachingMethodID !== 7">
      <div class="col-md-12">
        <mdc-textfield type="text"
                       ref="searchCriteriaEndTeaching"
                       name="criteriaEndTeaching"
                       :visible="visible"
                       v-model="protocol.criteriaEndTeaching"
                       data-vv-validate-on="none"
                       :class="{'is-invalid': errors.has('criteriaEndTeaching')}"
                       v-validate="'max:1000'"
                       :label="'protocol.criteria_end_teaching' | trans"
                       :data-vv-as="'protocol.criteria_end_teaching' | trans"/>

        <span class="invalid-feedback"
              v-if="errors.has('criteriaEndTeaching')">
                  <strong>{{ errors.first('criteriaEndTeaching') }}</strong>
                </span>
      </div>
    </div>
    <!----- criteriaEndTeaching ----->

    <!----- criteriaEndProtocol ----->
    <div class="form-group row"
         v-if="('criteriaEndProtocol' in protocol) && selectedTeachingMethodID !== 7">
      <div class="col-md-12">
        <mdc-textfield type="text"
                       ref="searchCriteriaEndProtocol"
                       name="criteriaEndProtocol"
                       :visible="visible"
                       v-model="protocol.criteriaEndProtocol"
                       data-vv-validate-on="none"
                       :class="{'is-invalid': errors.has('criteriaEndProtocol')}"
                       v-validate="'max:1000'"
                       :label="'protocol.criteria_end_protocol' | trans"
                       :data-vv-as="'protocol.criteria_end_protocol' | trans"/>

        <span class="invalid-feedback"
              v-if="errors.has('criteriaEndProtocol')">
                  <strong>{{ errors.first('criteriaEndProtocol') }}</strong>
                </span>
      </div>
    </div>
    <!----- criteriaEndProtocol ----->

    <!----- synthesisStrategy ----->
    <div class="form-group row"
         v-if="('synthesisStrategy' in protocol)">
      <div class="col-md-12">
        <mdc-textfield type="text"
                       ref="searchSynthesisStrategy"
                       name="synthesisStrategy"
                       :visible="visible"
                       v-model="protocol.synthesisStrategy"
                       :class="{'is-invalid': errors.has('synthesisStrategy')}"
                       data-vv-validate-on="none"
                       v-validate="'max:1000'"
                       :label="'protocol.synthesisStrategy' | trans"
                       :data-vv-as="'protocol.synthesisStrategy' | trans"/>
        <span class="invalid-feedback"
              v-if="errors.has('synthesisStrategy')">
                  <strong>{{ errors.first('synthesisStrategy') }}</strong>
                </span>
      </div>
    </div>
    <!----- synthesisStrategy ----->


  </div>
</template>

<script>

  import axios from 'axios';
  import uniqBy from 'lodash/uniqBy';
  import {DIRECTORY_TYPES, TRANSFER_CONDITION} from '../../protocols/constants.js';
  import debounce from 'lodash/debounce';
  import autocompleteSearch from '../../../common/autocompleteSearch/components/autocompleteSearch';

  export default {
    props: {
      'protocol': {
        type: Object
      },
      'visible': {
        type: Boolean,
        default() {
          return true;
        },
      },
      'selectedTeachingMethodID': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },

    data() {
      return {
        apiUrl: '/protocols/',
        teachingMethodDescriptionValidated: null,
        skillFieldValidated: false,
        autocomplete: [],
      };
    },

    components: {
      autocompleteSearch
    },

    inject: ["parentValidator"],

    created() {
      this.$validator = this.parentValidator;
    },

    computed: {

      isDTT: function() {
        return this.selectedTeachingMethodID == 1;
      },

      isSimple: function() {
        return this.selectedTeachingMethodID == 2;
      },

      isMand: function() {
        return this.selectedTeachingMethodID == 3;
      },

      isUSD: function () {
        return this.selectedTeachingMethodID == 4;
      },

      isChain: function () {
        return this.selectedTeachingMethodID == 5;
      },

      isShaping(){
        return this.selectedTeachingMethodID == 6
      }

    },

    methods: {

      setIsChanged(change) {
        this.$emit('setIsChanged', change);
      },

      setTeachingMethodNewValue(value) {
        this.protocol.teachingMethodDescription = value;
      },

      setTeachingMethodNewValidated(text) {
        this.protocol.teachingMethodDescription = text;
        this.teachingMethodDescriptionValidated = true;
        this.autocomplete = [];
      },

      validatedTeachingMethodNew(error) {
        this.errors.items.push(error.items[0]);
      },

      onChangeTeachingMethodNew(search) {
        this.setIsChanged(true);
        this.searchAutocompleteTeachingMethod(DIRECTORY_TYPES.TEACHING_METHOD, search, this);
      },

      searchAutocomplete: debounce(
          async (search, vm) => {
            try {
              let response = await axios.get(vm.apiUrl + 'skill-fields/search/' +
                  '?search=' + search);
              vm.autocomplete = uniqBy(response.data.data, 'name');
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          250,
      ),

      searchAutocompleteTeachingMethod: debounce(
          async (typeId, search, vm) => {
            try {
              let response = await axios.get(vm.apiUrl + 'directories/search/' +
                  typeId + '?search=' + search);
              vm.autocomplete = uniqBy(response.data.data, 'title');
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          250,
      ),

      onChangeSkillField(search) {
        this.searchAutocomplete(search, this);
      },

      setSkillFieldValue(value) {
        this.protocol.skillField = value;
      },

      setSkillFieldValidated(text) {
        this.protocol.skillField = text;
        this.skillFieldValidated = true;
        this.autocomplete = [];
      },

      validatedSkillField(error) {
        this.errors.items.push(error.items[0]);
      },

    },




  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/ProtocolCriteration.vue